namespace GeniuzPOS.Purchase {
    export namespace ReportPurTaxLongService {
        export const baseUrl = 'Purchase/ReportPurTaxLong';

        export declare function Create(request: Serenity.SaveRequest<ReportPurTaxLongRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ReportPurTaxLongRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ReportPurTaxLongRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ReportPurTaxLongRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/ReportPurTaxLong/Create",
            Update = "Purchase/ReportPurTaxLong/Update",
            Delete = "Purchase/ReportPurTaxLong/Delete",
            Retrieve = "Purchase/ReportPurTaxLong/Retrieve",
            List = "Purchase/ReportPurTaxLong/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ReportPurTaxLongService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
